/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
 */
export interface GetCustomerPromotions200ResponseCustomerInternalPromotionsInner {
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    pointsExpense?: number;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    discountType?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    discountAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    allowRepeat?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    accumulated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    availableInShop?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    maxRedemptions?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    minExpense?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    timesPerPerson?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    internalDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    showPopup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    availableInPos?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    availableInAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    pickupType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    freeDelivery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    deleted?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    products?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    customers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    customerIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    locations?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetCustomerPromotions200ResponseCustomerInternalPromotionsInner
     */
    weekdays?: Array<string>;
}

/**
 * Check if a given object implements the GetCustomerPromotions200ResponseCustomerInternalPromotionsInner interface.
 */
export function instanceOfGetCustomerPromotions200ResponseCustomerInternalPromotionsInner(value: object): value is GetCustomerPromotions200ResponseCustomerInternalPromotionsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerFromJSON(json: any): GetCustomerPromotions200ResponseCustomerInternalPromotionsInner {
    return GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerFromJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerPromotions200ResponseCustomerInternalPromotionsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'pointsExpense': json['pointsExpense'] == null ? undefined : json['pointsExpense'],
        'discountType': json['discountType'] == null ? undefined : json['discountType'],
        'discountAmount': json['discountAmount'] == null ? undefined : json['discountAmount'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'allowRepeat': json['allowRepeat'] == null ? undefined : json['allowRepeat'],
        'accumulated': json['accumulated'] == null ? undefined : json['accumulated'],
        'availableInShop': json['availableInShop'] == null ? undefined : json['availableInShop'],
        'code': json['code'] == null ? undefined : json['code'],
        'maxRedemptions': json['maxRedemptions'] == null ? undefined : json['maxRedemptions'],
        'minExpense': json['minExpense'] == null ? undefined : json['minExpense'],
        'timesPerPerson': json['timesPerPerson'] == null ? undefined : json['timesPerPerson'],
        'internalDescription': json['internalDescription'] == null ? undefined : json['internalDescription'],
        'showPopup': json['showPopup'] == null ? undefined : json['showPopup'],
        'availableInPos': json['availableInPos'] == null ? undefined : json['availableInPos'],
        'availableInAdmin': json['availableInAdmin'] == null ? undefined : json['availableInAdmin'],
        'pickupType': json['pickupType'] == null ? undefined : json['pickupType'],
        'freeDelivery': json['freeDelivery'] == null ? undefined : json['freeDelivery'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'categories': json['categories'] == null ? undefined : json['categories'],
        'products': json['products'] == null ? undefined : json['products'],
        'customers': json['customers'] == null ? undefined : json['customers'],
        'customerIds': json['customerIds'] == null ? undefined : json['customerIds'],
        'locations': json['locations'] == null ? undefined : json['locations'],
        'weekdays': json['weekdays'] == null ? undefined : json['weekdays'],
    };
}

export function GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerToJSON(json: any): GetCustomerPromotions200ResponseCustomerInternalPromotionsInner {
    return GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerToJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerToJSONTyped(value?: GetCustomerPromotions200ResponseCustomerInternalPromotionsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'pointsExpense': value['pointsExpense'],
        'discountType': value['discountType'],
        'discountAmount': value['discountAmount'],
        'enabled': value['enabled'],
        'allowRepeat': value['allowRepeat'],
        'accumulated': value['accumulated'],
        'availableInShop': value['availableInShop'],
        'code': value['code'],
        'maxRedemptions': value['maxRedemptions'],
        'minExpense': value['minExpense'],
        'timesPerPerson': value['timesPerPerson'],
        'internalDescription': value['internalDescription'],
        'showPopup': value['showPopup'],
        'availableInPos': value['availableInPos'],
        'availableInAdmin': value['availableInAdmin'],
        'pickupType': value['pickupType'],
        'freeDelivery': value['freeDelivery'],
        'deleted': value['deleted'],
        'categories': value['categories'],
        'products': value['products'],
        'customers': value['customers'],
        'customerIds': value['customerIds'],
        'locations': value['locations'],
        'weekdays': value['weekdays'],
    };
}

